import { observable, action, runInAction, decorate, computed } from 'mobx';

import agent from '../../api/agent';
import Moment from 'moment';
import cookie from 'js-cookie'
import ReactGA from 'react-ga';

class DGRStore {


    //TODO - split club data into another store



    /////////
    ////////DATA
    ////////

    debugMode = false 

    //user data
    values = this.defaultValues();

    //Club data
    clubDataLoaded = false
    haveClubDataNumber = false
    club_number = ''
    club_product_id = ''
    version = { version: '0.0.0' }

    clubValues = {
        name: '',
        full_address: '',
        address_state: '',
        type: ''
    }

    inProgress = false;
    loaderText = '';
    errors = undefined;


    get birthday(){
        const {year, month, day} = this.values
        var momentInstance = Moment
        const bd = momentInstance([year,month,day]).format("YYYY-MM-DD");
        return bd
    }

    createYMDfromBirthday(){
        if ( this.values.birthday ){
            var momentInstance = Moment
            var date = momentInstance( this.values.birthday, "YYYY-MM-DD" );
            this.values.year = date.year()
            this.values.day = date.date()
            this.values.month = date.month()
        }
    }

    defaultValues() {
        return {
            email: '',
            id: '',
            lead_number: '',
            first_name: '',
            last_name: '',
            phone: '',
            zipcode: '',
            gender: '',
            guestPass: '',
            birthday: '',
            pass_code: '',
            source: '',
            year: 2000,
            month: 0,
            day: 1,
            created_int: null,
            expires_int: null,
            is_waiver_signed: false,
            is_expired: false,
            is_guest: false,
            days_left: 0,
            is_minor: false,
            guardian_first_name: '',
            guardian_last_name: '',
            guardian_address: '',
            guardian_zip: '',
            guardian_city: '',
            guardian_state: '',
            guardian_phone: '',
            is_sms_allowed: false,
            membership_flow: false,
            return_visit_sent: false,
            certificateId: '',
            // Janrain CIAM Info
            username: '',
            password: '',
            passwordConfirm: '',
            forgot_field: 'forgot-username',
            securityToken: '',
            is_reset_sent: false,
            memberIdentifier: '',
            member_number: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            is_terms_accepted: false,
            isZuoraMember: false,
            signing_agreement_number: null
        };
    }

    states = [
        "AL",
        "AK",
        "AS",
        "AZ",
        "AR",
        "CA",
        "CO",
        "CT",
        "DE",
        "DC",
        "FM",
        "FL",
        "GA",
        "GU",
        "HI",
        "ID",
        "IL",
        "IN",
        "IA",
        "KS",
        "KY",
        "LA",
        "ME",
        "MH",
        "MD",
        "MA",
        "MI",
        "MN",
        "MS",
        "MO",
        "MT",
        "NE",
        "NV",
        "NH",
        "NJ",
        "NM",
        "NY",
        "NC",
        "ND",
        "MP",
        "OH",
        "OK",
        "OR",
        "PW",
        "PA",
        "PR",
        "RI",
        "SC",
        "SD",
        "TN",
        "TX",
        "UT",
        "VT",
        "VI",
        "VA",
        "WA",
        "WV",
        "WI",
        "WY"
    ]

    getVersion() {
        return agent.DGR.getVersion().then( versionData => {
            runInAction( () => {
                if ( versionData && versionData.version ){
                    this.version = versionData;
                }
            })
        }).catch( action((err) => {
            throw err;
        }));
    }

    ////////
    ////DATA METHODS
    //////
    //
    setProductID(productID){
        this.club_product_id = productID
    }

    setValue(key, value){
        if ( this.values[key] !== undefined ) {
            if (value !== null){
                this.values[key] = value
            }
        }
    }
    setGymValues(key, value){
        if ( this.clubValues[key] !== undefined ) {
            if (value){
                 this.clubValues[key] = value
            }
        }
    }

    clearValues(){
        cookie.remove( 'securityToken', { path: '/', domain: window.location.hostname });
        cookie.remove( 'isZuoraMember', { path: '/', domain: window.location.hostname });
        cookie.remove( 'loggedInUserName', { path: '/', domain: window.location.hostname });
        cookie.remove( 'enteredInfo', { path: '/', domain: window.location.hostname, secure: true });

        this.values = this.defaultValues();
    }

    /////////////////////////////////
    /////API CALLS

    //TODO api call with successful errors and unsuccessful errors - handle both
    getClubData(club_number){
        this.loaderText = 'Loading'
        this.inProgress = true;
        return agent.DGR.getClubData(
            club_number
        )
        .then( (response) => {
            runInAction( () => {
                for (var key in response) {
                    if (response.hasOwnProperty(key)) {
                        this.setGymValues(key, response[key])
                    }
                }
                if (this.clubValues.name){
                    this.clubDataLoaded = true
                    this.club_number = club_number
                    cookie.set('club_number', club_number);
                    cookie.set( 'kioskmode', '1', {
                        expires: ( new Date().getTime() + ( 30 * 24 * 60 * 60 * 1000 ) ),
                        path: '/',
                        domain: window.location.hostname
                    } );                    // Track the initial pageview, if they are loading the app up, or coming back from the delegate pages.
                    ReactGA.set({ dimension1: this.club_number });
                    ReactGA.set({ dimension2: this.clubValues.name });
                    ReactGA.set({ dimension7: new Date().getTime() });
                    ReactGA.pageview( window.location.pathname + window.location.search );
                }
                if (response.error){
                    alert(`Data for club number ${club_number} could not be loaded at this time`)
                    console.log(response.error)
                    cookie.remove('club_number', club_number)
                }
            })
        })
        .catch(action((err) => {
            alert(`Data for club number ${club_number} could not be loaded at this time`)
            this.errors = err.response && err.response.body && err.response.body.errors;
            cookie.remove('club_number', club_number)
        }))
        .finally( action(()=> {
            this.inProgress = false
        }));
    }
    enterPassUserCreds(){
        this.loaderText = 'Submitting'
        this.inProgress = true;
        this.errors = undefined;
        const { first_name, last_name  } = this.values
        var birthday = this.birthday
        const club_number = this.club_number
        return agent.DGR.enterPassUserCreds(
            first_name,
            last_name,
            birthday,
            club_number
        ).then( (response) => {
            runInAction( () => {
                for (var key in response) {
                    if (response.hasOwnProperty(key)) {
                        this.setValue(key, response[key])
                    }
                }
                ReactGA.set({ userId: this.values.lead_number });
                ReactGA.set({ dimension3: ''+this.values.id });
                ReactGA.set({ dimension4: ''+this.values.lead_number });
                ReactGA.set({ dimension5: this.values.pass_code });
                ReactGA.set({ dimension6: this.values.source });
                ReactGA.set({ dimension7: new Date().getTime() });
                return response
            })
        })
        .catch( action( (err) => {
            alert( 'There was a problem connecting to the server. Please wait a few minutes then try again.' );
        }))
        .finally(action(() => {
            this.inProgress = false;
        }));
    }

    enterPassGuestPass(){
        this.loaderText = 'Submitting'
        this.inProgress = true;
        this.errors = undefined;
        const { guestPass } = this.values
        const club_number = this.club_number
        return agent.DGR.enterPassGuestPass(
            guestPass, club_number
        ).then( (response) => {
            runInAction( () => {
                for (var key in response) {
                    if (response.hasOwnProperty(key)) {
                        this.setValue(key, response[key])
                    }
                }
                if (response.error){
                    this.errors = response.error
                }
                this.createYMDfromBirthday()
                ReactGA.set({ userId: this.values.lead_number });
                ReactGA.set({ dimension3: ''+this.values.id });
                ReactGA.set({ dimension4: ''+this.values.lead_number });
                ReactGA.set({ dimension5: this.values.pass_code });
                ReactGA.set({ dimension6: this.values.source });
                ReactGA.set({ dimension7: new Date().getTime() });

                return response
            })
        })
        .catch(action( (err) => {
            alert( 'There was a problem connecting to the server. Please wait a few minutes then try again.' )
        }))
        .finally(action(() => {
            this.inProgress = false;
        }));
    }
    createPass(){
        this.inProgress = true;
        this.errors = undefined;
        const { email, first_name, last_name,  phone, zipcode, gender, is_waiver_signed, is_sms_allowed } = this.values
        const { club_number }  = this
        var birthday = this.birthday
        return agent.DGR.createPass(
            email,
            first_name,
            last_name,
            birthday,
            club_number,
            phone,
            zipcode,
            gender,
            is_waiver_signed,
            is_sms_allowed
        ).then( (response) => {
            runInAction( () => {
                if ( response.error ) {

                    ReactGA.set({ dimension7: new Date().getTime() });
                    ReactGA.event({
                        category: 'Leads',
                        action: 'Lead Error'
                    });

                    return alert( response.message );
                }

                for (var key in response) {
                    if (response.hasOwnProperty(key)) {
                        this.setValue(key, response[key])
                    }
                }

                ReactGA.set({ dimension7: new Date().getTime() });
                ReactGA.event({
                    category: 'Leads',
                    action: 'Lead Created',
                    label: this.values.lead_number
                });

                this.createYMDfromBirthday();
                ReactGA.set({ userId: this.values.lead_number });
                ReactGA.set({ dimension3: ''+this.values.id });
                ReactGA.set({ dimension4: ''+this.values.lead_number });
                ReactGA.set({ dimension5: this.values.pass_code });
                ReactGA.set({ dimension6: this.values.source });
                ReactGA.set({ dimension7: new Date().getTime() });

                return response
            })
        })
        .catch(action( (err) => {
            //TODO - figure out a loss of connection error
            this.errors = err.message
            //throw err;
        }))
        .finally(action(() => { this.inProgress = false; }));
    }
    createLead(){
        this.loaderText = 'Submitting'
        this.inProgress = true;
        this.errors = undefined;
        const { email, first_name, last_name,  phone, zipcode, gender, is_waiver_signed  } = this.values
        const { club_number }  = this
        var birthday = this.birthday
        return agent.DGR.createPass(
            email,
            first_name,
            last_name,
            birthday,
            club_number,
            phone,
            zipcode,
            gender,
            is_waiver_signed
        ).then( (response) => {
            runInAction( () => {
                if ( response.error ) return alert( response.message );
                for (var key in response) {
                    if (response.hasOwnProperty(key)) {
                        this.setValue(key, response[key])
                    }
                }
                this.createYMDfromBirthday()
                ReactGA.set({ userId: this.values.lead_number });
                ReactGA.set({ dimension3: ''+this.values.id });
                ReactGA.set({ dimension4: ''+this.values.lead_number });
                ReactGA.set({ dimension5: this.values.pass_code });
                ReactGA.set({ dimension6: this.values.source });
                ReactGA.set({ dimension7: new Date().getTime() });

                return response
            })
        })
        .catch(action( (err) => {
            this.errors = err.message
            //throw err;
        }))
        .finally(action(() => { this.inProgress = false; }));
    }

    createPassWithGuardian(){
        this.loaderText = 'Submitting'
        this.inProgress = true;
        this.errors = undefined;
        const { email,
            first_name,
            last_name,
            phone,
            zipcode,
            gender,
            is_waiver_signed,
            is_sms_allowed,
            guardian_first_name ,
            guardian_last_name ,
            guardian_address ,
            guardian_zip ,
            guardian_city ,
            guardian_state ,
            guardian_phone
        } = this.values
        const { club_number }  = this
        var birthday = this.birthday
        return agent.DGR.createPassWithGuardian(
            email,
            first_name,
            last_name,
            birthday,
            club_number,
            phone,
            zipcode,
            gender,
            is_waiver_signed,
            is_sms_allowed,
            guardian_first_name ,
            guardian_last_name ,
            guardian_address ,
            guardian_zip ,
            guardian_city ,
            guardian_state ,
            guardian_phone
        ).then( (response) => {
            runInAction( () => {
                if ( response.error ) return alert( response.message );
                for (var key in response) {
                    if (response.hasOwnProperty(key)) {
                        this.setValue(key, response[key])
                    }
                }
                this.createYMDfromBirthday()
                ReactGA.set({ userId: this.values.lead_number });
                ReactGA.set({ dimension3: ''+this.values.id });
                ReactGA.set({ dimension4: ''+this.values.lead_number });
                ReactGA.set({ dimension5: this.values.pass_code });
                ReactGA.set({ dimension6: this.values.source });
                ReactGA.set({ dimension7: new Date().getTime() });

                return response
            })
        })
        .catch(action( (err) => {
            //TODO - figure out a loss of connection error
            this.errors = err.message
            //throw err;
        }))
        .finally(action(() => { this.inProgress = false; }));
    }
    checkIn(){
        this.inProgress = true;
        this.errors = undefined;
        const {  lead_number, return_visit_sent  } = this.values
        const {  club_number  } = this
        if ( return_visit_sent ) {
            this.inProgress = false;
            return true;
        }
        this.values.return_visit_sent = true;

        return agent.DGR.checkIn(
            lead_number ,
            club_number,
        ).then( (response) => {
            if (response.error){
                //TODO - user still will still have successfully navigate to landing page
                console.log(response.error)
            }
        })
        .catch(action( (err) => {
            //TODO - user still will still have successfully navigate to landing page
            this.errors = err.message
        }))
        .finally(action(() => { this.inProgress = false; }));
    }

    authLogin() {
        const { username, password, securityToken } = this.values
        this.inProgress = true;
        this.errors = undefined;
        return agent.DGR.authLogin(
            username,
            password,
            securityToken
        ).then( response => {
            if ( response && response.headers && response.headers['security-token'] ) {
                var securityToken = response.headers['security-token'];
                this.setValue( 'securityToken', securityToken );
                cookie.set( 'securityToken', securityToken, { path: '/', domain: window.location.hostname });
                if ( response.body && response.body.username ) {
                    cookie.set( 'loggedInUserName', this.values.username, { path: '/', domain: window.location.hostname });
                }
                if ( response.headers.iszuoramember === 'true' || response.headers.iszuoramember === 'false' ) {
                    cookie.set( 'isZuoraMember', ( response.headers.iszuoramember === 'true' ), { path: '/', domain: window.location.hostname });
                    this.setValue( 'isZuoraMember', ( response.headers.iszuoramember === 'true' ) );
                }
                return agent.DGR.authUserInfo( username, securityToken ).then( response2 => {
                    if ( !response2 ) return null;
                    if ( response2.body.firstName ) this.setValue( 'first_name', response2.body.firstName );
                    if ( response2.body.lastName ) this.setValue( 'last_name', response2.body.lastName );
                    if ( response2.body.memberships && response2.body.memberships.length > 0 && response2.body.memberships[ response2.body.memberships.length - 1 ].number ) {
                        this.setValue( 'member_number', response2.body.memberships[ response2.body.memberships.length - 1 ].number );
                    }
                    // Now we have to check for any unsigned agreements.
                    if ( !this.values.member_number ) {
                        return this.loginOrRedirect();
                    } else {
                        return agent.DGR.authUnsignedAgreements( this.values.member_number ).then( response3 => {
                            if ( response3 && response3.body[0] && response3.body[0].subscriptionNumber ) {
                                this.setValue( 'signing_agreement_number', response3.body[0].subscriptionNumber );
                            }
                            return this.loginOrRedirect();
                        }).catch( err => {
                            console.log('Unable to get Unsigned Agreements');
                            return this.loginOrRedirect();
                        });
                    }
                });
            } else {
                this.errors = 'The username/password entered is not valid. Please try again.';
            }
        }).catch( action( err => {
            if ( err && err.response && err.response.body && err.response.body.errorMessage ) {
                this.errors = err.response.body.errorMessage;
            } else {
                this.errors = 'The username/password entered is not valid. Please try again.';
            }
        })).finally( action( () => {
            this.inProgress = false;
        }));
    }

    loginOrRedirect() {
        if ( ['buy_pt','resign_pt','upgrade_membership','add_family','buy_privileges'].indexOf( this.club_product_id ) > -1 ) {
            return this.sendToDelegate();
        }
        if ( !this.values.member_number ) {
            return Promise.resolve( '/auth/login' );
        }
        if ( !this.club_product_id ) {
            return Promise.resolve( '/member/menu' );
        }
        if ( this.values.isZuoraMember ) {
            if ( this.isProductAvailable() ) {
                return Promise.resolve( '/member/purchase' );
            } else {
                return Promise.resolve( '/member/unavailable' );
            }
        } else if ( this.isSecureAvailable() ) {
            return Promise.resolve( '/member/purchase' );
        }
        return this.sendToDelegate();
    }

    isProductAvailable() {
        return ( ['buy_pt','add_family','easypay','late_acceptance'].indexOf( this.club_product_id ) > -1 );
    }

    isSecureAvailable() {
        return ( ['training_pin','easypay','late_acceptance'].indexOf( this.club_product_id ) > -1 );
    }

    productLabels() {
        return {
            buy_pt: 'Buy Personal Training',
            resign_pt: 'Re-Sign Personal Training',
            upgrade_membership: 'Upgrade Membership',
            add_family: 'Add Family Member',
            buy_privileges: 'Add Services',
            easypay: 'Enroll / Manage EasyPay',
            training_pin: 'Enroll / Manage Personal Training PIN',
            late_acceptance: 'Late Acceptance'
        };
    }

    sendToDelegate() {
        var self = this;
        return new Promise( ( resolve, reject ) => {

            cookie.set( 'enteredInfo', self.values, {
                expires: ( new Date().getTime() + 300000 ),
                path: '/',
                domain: window.location.hostname,
                secure: true
            } );

            window.name = '';

            var iframe = document.createElement('iframe'),
                host = window.location.hostname,
                dgrSection = document.querySelector( '.dgrSection' );
            iframe.id = 'hiddenframe';
            iframe.src = 'https://' + host + '/membershipSalesOnline';
            if ( dgrSection ) {
                var str = '<div id="loading">';
                str += '<h1>Loading...</h1>';
                str += '</div>';
                dgrSection.innerHTML = str;
            }
            document.body.appendChild( iframe );

            // Wait a couple of seconds.
            setTimeout( function() {
                var contentDoc = ( iframe.contentWindow || iframe.contentDocument );
                try {
                    if ( contentDoc && contentDoc.document ) contentDoc = contentDoc.document;
                    // Delete any old session cookies, so we can start fresh.
                    contentDoc.cookie = 'JSESSIONID= ; Path=/membershipSalesOnline;';
                    contentDoc.cookie = 'JSESSIONID= ; Path=/;';
                } catch (o_0) {}

                var redirectUrl = 'http://';
                redirectUrl += host;
                redirectUrl += '/go/dgr/membership_delegate.html';
                redirectUrl += '?product_type=' + self.club_product_id;
                redirectUrl += '&club_number=' + self.club_number;
                redirectUrl += '&ran=' + new Date().getTime();
                resolve( redirectUrl );

            }, 2000);
        });
    }

    authForgot() {
        const { email, forgot_field } = this.values
        this.inProgress = true;
        this.errors = undefined;
        return agent.DGR.authForgot(
            email,
            forgot_field
        ).then( response => {
            return response;
        }).catch( response => {
            return response;
        }).finally( action( () => {
            this.inProgress = false;
        }));
    }

    authValidate() {
        const { memberIdentifier } = this.values
        var birthday = this.birthday

        return agent.DGR.authValidate(
            memberIdentifier,
            birthday
        ).then( response => {

            if ( response && response.headers && response.headers['validation-token'] ) {
                var securityToken = response.headers['validation-token'];
                this.setValue( 'securityToken', securityToken );
                cookie.set( 'securityToken', securityToken, { path: '/', domain: window.location.hostname });
            }

            var data = response.body;
            if ( data ) {
                this.setValue( 'first_name', data.firstName );
                this.setValue( 'last_name', data.lastName );
                if ( data.address ) {
                    this.setValue( 'address1', data.address.address1 );
                    this.setValue( 'address2', data.address.address2 );
                    this.setValue( 'city', data.address.city );
                    this.setValue( 'state', data.address.state );
                    this.setValue( 'zipcode', data.address.zip );
                }
                this.setValue( 'email', data.email );
                this.setValue( 'birthday', data.birthDate );
                if ( data.phones && data.phones[0] && data.phones[0].number ) {
                    this.setValue( 'phone', data.phones[0].number );
                }
                if ( data.memberships && data.memberships[ data.memberships.length - 1 ] && data.memberships[ data.memberships.length - 1 ].number ) {
                    this.setValue( 'member_number', data.memberships[ data.memberships.length - 1 ].number );
                }
                this.createYMDfromBirthday();
            }

            return data;
        }).catch( action( err => {
            if ( err && err.response && err.response.body && err.response.body.errorMessage ) {
                this.errors = err.response.body.errorMessage;
            } else {
                this.errors = 'Error connecting to the server. Please try again later.';
            }
        })).finally( action( () => {
            this.inProgress = false;
        }));
    }

    authValidateEmail() {
        const { email, securityToken } = this.values
        return agent.DGR.authValidateEmail( email, securityToken ).then( response => {
            var data = response.body;
            return data;
        });
    }

    authValidateUsername() {
        const { username, securityToken } = this.values
        return agent.DGR.authValidateUsername( username, securityToken ).then( response => {
            var data = response.body;
            return data;
        });
    }

    authCreate() {
        const {
            first_name,
            last_name,
            birthday,
            address1,
            address2,
            city,
            state,
            zipcode,
            phone,
            email,
            member_number,
            username,
            password,
            securityToken
        } = this.values;

        var userObject = {
            "firstName": first_name,
            "lastName": last_name,
            "birthDate": birthday,
            "address": {
                "address1": address1,
                "address2": address2,
                "city": city,
                "state": state,
                "zip": zipcode
            },
            "phoneNumbers": [
                {
                    "number": phone,
                    "priority": "PRIMARY"
                }
            ],
            "email": email,
            "memberships": [
                {
                    "number": member_number
                }
            ],
            "userName": username,
            "password": password
        };

        return agent.DGR.authCreate( userObject, securityToken ).then( response => {
            return true;
        }).catch( action( err => {
            if ( err && err.response && err.response.body && err.response.body.errorMessage ) {
                this.errors = err.response.body.errorMessage;
            } else {
                this.errors = 'Error connecting to the server. Please try again later.';
            }
        }));

    }

    trackSelection( lead_number, selection ) {
        return agent.DGR.trackSelection( lead_number, selection );
    }

}

decorate(DGRStore, {
    debugMode: observable,
    loaderText: observable,
    inProgress: observable,
    setValue: action,
    setProductID: action,
    createPass: action,
    createLead: action,
    getClubData: action,
    clearValues: action,
    values: observable,
    clubValues: observable,
    errors: observable,
    birthday:computed,
    enterPassFormSubmitAttempted: observable,
    clubDataLoaded: observable,
    haveClubDataID: observable,
    club_number: observable,
    club_product_id: observable
});

export default new DGRStore();



// WEBPACK FOOTER //
// ./src/stores/DGRStore/index.js